import { ProjectUser } from '../types/types';
import { normalize, schema } from 'normalizr';

interface ProjectUsersNormalizedResult {
    ids: number[];
    entities: Record<string, ProjectUser>;
}

export const getProjectUsersNormalized = (
    projectUsers: ProjectUser[]
): ProjectUsersNormalizedResult => {
    const userSchema = new schema.Entity('users');
    const normalizedData = normalize(projectUsers, [userSchema]);

    const result: ProjectUsersNormalizedResult = {
        ids: normalizedData.result,
        entities: normalizedData.entities.users || {},
    };

    return result;
};
